module.exports = __webpack_public_path__ + "static/assets/1915c266b9444348e709aa415ceb7162.svg";